import React from "react";

import { basic } from "@/mappings/plans";
import { cx } from "@/utils";
import Modal, { ModalContent, ModalHeader } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";

import { Cta, useStripePlanUpgrade } from "../../PlanModal";
import * as PlanCard from "../../PlanModal/PlanCard";

import styles from "./UpsaleModals.module.css";

const BasicPlanModal = (props: Partial<ModalProps>) => {
  const { upgrade, disabled, isLoading } = useStripePlanUpgrade("basic");

  return (
    <PlanCard.Root plan={basic}>
      <Modal contentLoading={isLoading} data-testid="upsale-modal" {...props}>
        <ModalHeader className={cx(styles.header, styles.basicHeader)}>
          <PlanCard.Name variant="subtitle-1" />

          <PlanCard.Description variant="h2" />
        </ModalHeader>
        <ModalContent>
          <div className={styles.inline}>
            <PlanCard.Price /> <PlanCard.Legal variant="body-1" />
            <br />
            <PlanCard.MonthlyPrice />
          </div>
          <PlanCard.FeatureTitle margin="default" />
          <PlanCard.Features />
          <Cta
            disabled={disabled}
            onClick={upgrade}
            data-testid="upgrade-to-basic"
          >
            {L.UPSALE_BASIC_CTA}
          </Cta>
        </ModalContent>
      </Modal>
    </PlanCard.Root>
  );
};

export default BasicPlanModal;
